export default "__VITE_ASSET__1ef6b3dd__"